module.exports = __webpack_public_path__ + "zmenseni-prsou_1_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zmenseni-prsou_1_after.jpg
// module id = 1277
// module chunks = 0